import React from 'react';
import { useBreadcrumb } from '@/core/context/breadcrumb/BreadcrumbContext';
import { normalizeSidebarHref } from '@/core/context/sidebar/sidebar.utils';
import AppNavLink from '../sidebar/AppNavLink';

const PageBreadcrumb: React.FC = () => {
    const { breadcrumbs } = useBreadcrumb();

    return (
        <nav className="page-breadcrumb" aria-label="Navegação">
            <div className="page-breadcrumb-trail">
                <AppNavLink href={normalizeSidebarHref('/home')} className="page-breadcrumb-item">
                    <span className="material-icons breadcrumb-home-icon">home</span>
                    <span>Home</span>
                </AppNavLink>
                {breadcrumbs.map((breadcrumb, index) => {
                    const isLast = index === breadcrumbs.length - 1;
                    return (
                        <React.Fragment key={`${breadcrumb.label}-${index}`}>
                            <span className="page-breadcrumb-sep">/</span>
                            {isLast ? (
                                <span className="page-breadcrumb-item page-breadcrumb-current" aria-current="page">
                                    {breadcrumb.label}
                                </span>
                            ) : breadcrumb.url ? (
                                <AppNavLink
                                    href={normalizeSidebarHref(breadcrumb.url)}
                                    className="page-breadcrumb-item">
                                    {breadcrumb.label}
                                </AppNavLink>
                            ) : (
                                <span className="page-breadcrumb-item page-breadcrumb-current">{breadcrumb.label}</span>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </nav>
    );
};

export default PageBreadcrumb;
